export const logError = (func, message, error) => {
    console.error("function="+ func + "level=error," + " message=" + message + "," + "error=" + error )
}

export const logInfo = (func, message) => {
    console.info("function="+ func + "level=info," + " message=" + message)
}

export const logSuccess = (func, message, success) => {
    console.info("function="+ func + "level=success," + "message=" + message + "," + "success=" + success )
}